<template>
    <v-container v-if="contracts.length > 0" class="pa-0 mb-4">
        <heading-section class="d-flex">
            {{ $vuetify.lang.t('$vuetify.widgets.pending_contracts.title') }}
        </heading-section>
        <v-expansion-panels tile flat accordion>
            <v-expansion-panel v-for="(contract ,i) in contracts"
                               :key="i">
                <v-expansion-panel-header expand-icon="mdi-menu-down"
                                          class="py-1 pr-2">
                    <v-row class="pr-2">
                        <v-col cols="auto">
                            <p class="ma-0">{{ contract.created_at | date }}</p>
                        </v-col>
                        <v-col>
                            <p class="mb-0">{{ contract.model_name }}</p>
                            <p class="mb-0 caption grey--text">{{ $vuetify.lang.t('$vuetify.form_items.ab_number_prefix') }} {{ contract.ab_number }}</p>
                        </v-col>
                        <v-col cols="auto"
                               :class="{ 'success--text': contract.contract_type.reward >= 0, 'error--text': contract.contract_type.reward < 0 }">
                            {{ contract.contract_type.reward | number | balance }}
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-divider class="mb-4"></v-divider>
                    <p class="mb-0">{{ $vuetify.lang.t('$vuetify.form_items.contract_date') }}: {{ contract.order_date_customer | date }}</p>
                    <p class="mb-0">{{ $vuetify.lang.t('$vuetify.form_items.potential_delivery_date') }}: {{ contract.potential_delivery_date | date }}</p>
                    <p class="mb-0">
                        {{ $vuetify.lang.t('$vuetify.transaction_labels.vin') }}:
                        <template v-if="contract.vin">
                            {{ contract.vin }}
                        </template>
                        <template v-else>
                            {{ $vuetify.lang.t('$vuetify.widgets.transactions.empty_vin') }}
                        </template>
                    </p>
                    <p class="mb-0" v-if="contract.commission">{{ $vuetify.lang.t('$vuetify.form_items.commission') }}: {{ contract.commission }}</p>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
    // components
    import HeadingSection from '../../components/HeadingSection';

    export default {
        name: 'pending-contracts',
        components: {
            HeadingSection,
        },
        props: {
            contracts: {
                required: true,
                type: Array,
            },
        },
    }
</script>
